import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GalleryModule, GalleryItem, ImageItem, GalleryRef, Gallery  } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';
import { AvailabilityService, PIMService } from 'core-lib';


@Component({
    selector: 'app-image-gallery1',
    imports: [GalleryModule, LightboxModule],
    templateUrl: './image-gallery1.component.html',
    styleUrl: './image-gallery1.component.scss'
})
export class ImageGallery1Component implements OnInit {

  @Input() roomCode:string|undefined;
  @Input({ required: true }) hotelCode:string|undefined;
  @Input() preventLightbox:boolean = false;
  @Input() context:string = '';  // for giving identifible id to gallery. Needed if many instances of same gallery exist in same page. Eg in availability and the read more popup in
  images: GalleryItem[];
  id:string
  galleryRef:any;
  testId:string = this.preventLightbox ? 'gallery-static' : 'gallery-lightbox';

  constructor(private PIM:PIMService, private gallery: Gallery, private avService:AvailabilityService) {

  }

  ngOnInit(): void {

    if (this.roomCode) {
      this.id = this.context + this.roomCode;
    }
    else {
      this.id =  this.context + this.hotelCode || "noid";
    }

    this.galleryRef = this.gallery.ref(this.id);

    //have to use a slight timeout, because the images will render too big otherwise.
    /* setTimeout(() => {

    }, 400); */

    this.getImages();
  }

  getImages():void {
    let imagesFromPim;
    let altTextDefault = "Room image"
    if (this.roomCode && this.hotelCode) {
      imagesFromPim = this.PIM.getImagesForRoomCode(this.hotelCode, this.roomCode);
    }
    else if (!this.roomCode && this.hotelCode ) {
      imagesFromPim = this.PIM.getImagesForHotelCode(this.hotelCode);
      let altTextDefault = "Hotel image"
    }


    let galleryItems:ImageItem[] = [];
    imagesFromPim?.forEach((img:any, index: number) => {
      galleryItems.push(
        new ImageItem({
          src: img.src,
          thumb: img.thumb ?? img.src,
          alt: img.alt ?? `${altTextDefault} ${index}`
        }),
      )
    });


    this.images = galleryItems;
  }

  reset() {
    setTimeout(() => {
      this.galleryRef.load( this.images);
    },800);

  }
}
